/*
  ===================================================================
  naturism カテゴリ体験ページ JS (2026-07-04)
  1. 診断 (LINE quick-quiz と同一設問・採点ロジックの逐語移植)
  2. 3D リングカルーセル (drag / flick / click / arrow keys)
  3. scroll-reveal (IntersectionObserver)
  依存ライブラリなし。html.nc-js が付与された時のみ拡張が有効
  (JS 無効時は CSS 側の静的グリッド + 素の <a> リンクで購入可能)。
  ===================================================================
*/
(function () {
  'use strict';

  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ============================================================
     1. 診断 — 設問/採点は apps/worker quick-quiz.ts と同一
     ============================================================ */
  /* ---- 9問版(2026-07-20オーナー仕様・ホームnx-lineup-v2.jsと同一config) ----
     Q1,Q3-Q8=加点 / Q2=料理順位付け(1位+2,2位+1,3位+1) / Q9=加点なし(同点処理のみ) */
  var QTYPES = ['blue', 'pink', 'premium']; /* 度数バーは必ずこの固定順 */
  var TYPE_LABELS = { blue: 'ブルー度', pink: 'ピンク度', premium: 'プレミアム度' };
  var QUESTIONS = [
    {
      id: 1,
      text: 'Q1. 普段の食事の傾向は?',
      kind: 'single',
      options: [
        { label: '揚げ物・脂っこい料理が好き', pts: { pink: 0, blue: 2, premium: 2 } },
        { label: 'ご飯・パン・麺類が多い', pts: { pink: 1, blue: 0, premium: 2 } },
        { label: 'バランスを意識', pts: { pink: 2, blue: 1, premium: 0 } },
        { label: '外食やコンビニ中心', pts: { pink: 0, blue: 1, premium: 2 } },
      ],
    },
    {
      id: 2,
      text: 'Q2. 好きな料理は? 1位〜3位の順にタップしてください',
      kind: 'rank',
      options: ['和食', '中華', '焼肉', 'イタリアン', 'ラーメン／麺類'],
    },
    {
      id: 3,
      text: 'Q3. 体型管理の目標は?',
      kind: 'single',
      options: [
        { label: '体重を落としたい', pts: { pink: 0, blue: 1, premium: 2 } },
        { label: '体型を維持したい', pts: { pink: 1, blue: 2, premium: 0 } },
        { label: '健康のため', pts: { pink: 1, blue: 0, premium: 2 } },
        { label: '美容のため', pts: { pink: 1, blue: 0, premium: 2 } },
      ],
    },
    {
      id: 4,
      text: 'Q4. 食事のリズムで当てはまるのは?',
      kind: 'single',
      options: [
        { label: '外食・会食がとても多い', pts: { pink: 1, blue: 3, premium: 2 } },
        { label: '食事の時間が不規則になりがち', pts: { pink: 0, blue: 2, premium: 1 } },
        { label: '自炊中心・今の食習慣を保ちたい', pts: { pink: 1, blue: 1, premium: 0 } },
        { label: '特に悩みはない', pts: { pink: 1, blue: 0, premium: 0 } },
      ],
    },
    {
      id: 5,
      text: 'Q5. 続けるうえで重視したいのは?',
      kind: 'single',
      options: [
        { label: '美容も一緒に考えたい', pts: { pink: 3, blue: 0, premium: 0 } },
        { label: '食事の量が多くなりがち', pts: { pink: 0, blue: 2, premium: 1 } },
        { label: '全体的にケアしたい', pts: { pink: 0, blue: 0, premium: 3 } },
        { label: '特になし', pts: { pink: 1, blue: 0, premium: 0 } },
      ],
    },
    {
      id: 6,
      text: 'Q6. 甘いもの・間食の頻度は?',
      kind: 'single',
      options: [
        { label: 'ほぼ毎日食べる', pts: { pink: 0, blue: 1, premium: 3 } },
        { label: '週に数回', pts: { pink: 0, blue: 0, premium: 2 } },
        { label: 'たまに', pts: { pink: 1, blue: 1, premium: 0 } },
        { label: 'ほとんど食べない', pts: { pink: 2, blue: 0, premium: 0 } },
      ],
    },
    {
      id: 7,
      text: 'Q7. 運動の習慣は?',
      kind: 'single',
      options: [
        { label: 'ほとんど運動しない', pts: { pink: 0, blue: 1, premium: 2 } },
        { label: '軽く歩く程度', pts: { pink: 1, blue: 1, premium: 0 } },
        { label: '週1〜2回運動する', pts: { pink: 1, blue: 1, premium: 0 } },
        { label: 'しっかり運動している', pts: { pink: 2, blue: 0, premium: 0 } },
      ],
    },
    {
      id: 8,
      text: 'Q8. 続けやすさ・価格の考え方は?',
      kind: 'single',
      options: [
        { label: 'まずは手軽に・コスパ重視', pts: { pink: 1, blue: 2, premium: 0 } },
        { label: '効果重視でしっかり投資したい', pts: { pink: 0, blue: 0, premium: 3 } },
        { label: '1日55円〜150円くらいなら特に気にならない', pts: { pink: 1, blue: 0, premium: 2 } },
        { label: '根拠(機能性表示食品など)があるものがいい', pts: { pink: 0, blue: 0, premium: 2 } },
      ],
    },
    {
      id: 9,
      text: 'Q9. naturism を試すのは?',
      kind: 'single',
      options: [
        { label: '初めて', pts: null },
        { label: '飲んだことある', pts: null },
        { label: '今飲んでいて別種類を検討中', pts: null },
      ],
    },
  ];
  var Q2_CUISINE_TYPE = { 和食: 'pink', イタリアン: 'pink', 中華: 'blue', 焼肉: 'blue', 'ラーメン／麺類': 'premium' };
  var Q2_RANK_POINTS = [2, 1, 1];

  var LINE_META = {
    blue: {
      name: 'naturism Blue',
      desc: '脂っこい食事や外食が多いあなたには、黒烏龍茶で「食べたあと」をケアするブルーがぴったり。',
    },
    pink: {
      name: 'KOSO in naturism Pink',
      desc: '美容やバランスを大切にするあなたには、酵素で内側からととのえるピンクがぴったり。',
    },
    premium: {
      name: 'naturism Premium',
      desc: '糖質も脂質もしっかりケアして結果を出したいあなたには、トータルケアのプレミアムがぴったり。',
    },
  };
  var COMPARE_URLS = {
    blue: '/pages/compare#nxcp-blue',
    pink: '/pages/compare#nxcp-pink',
    premium: '/pages/compare#nxcp-premium',
  };

  /* answers: 質問index順。single=選択肢index / rank=料理ラベル3件 */
  function scoreQuiz(answers) {
    var s = { blue: 0, pink: 0, premium: 0 };
    QUESTIONS.forEach(function (q, i) {
      var a = answers[i];
      if (a == null) return;
      if (q.kind === 'rank') {
        a.forEach(function (label, r) {
          var t = Q2_CUISINE_TYPE[label];
          if (t) s[t] += Q2_RANK_POINTS[r] || 0;
        });
      } else {
        var pts = q.options[a] && q.options[a].pts;
        if (pts) {
          s.blue += pts.blue || 0;
          s.pink += pts.pink || 0;
          s.premium += pts.premium || 0;
        }
      }
    });
    /* 同点処理: Q9=初めて→blue>pink>premium / それ以外→premium>blue>pink */
    var prio = answers[8] === 0 ? ['blue', 'pink', 'premium'] : ['premium', 'blue', 'pink'];
    var max = Math.max(s.blue, s.pink, s.premium);
    var rec = prio.filter(function (t) {
      return s[t] === max;
    })[0];
    return { rec: rec, scores: s };
  }

  function initQuiz(root) {
    var card = root.querySelector('[data-nc-quiz]');
    if (!card) return;
    var body = card.querySelector('[data-nc-quiz-body]');
    var sub = card.querySelector('[data-nc-quiz-sub]');
    var progress = card.querySelector('[data-nc-quiz-progress]');
    var bar = card.querySelector('[data-nc-quiz-bar]');
    var answers = [];
    var idx = 0;

    function el(tag, cls, text) {
      var n = document.createElement(tag);
      if (cls) n.className = cls;
      if (text) n.textContent = text;
      return n;
    }

    function renderQuestion() {
      var q = QUESTIONS[idx];
      body.innerHTML = '';
      progress.hidden = false;
      bar.style.width = (idx / QUESTIONS.length) * 100 + '%';
      sub.textContent = '質問 ' + q.id + ' / ' + QUESTIONS.length;
      body.appendChild(el('p', 'nc-quiz__q', q.text));
      if (q.kind === 'rank') renderRank(q);
      else renderSingle(q);
      if (idx > 0) {
        var back = el('button', 'nc-quiz__back', '← ひとつ前に戻る');
        back.type = 'button';
        back.addEventListener('click', function () {
          idx = Math.max(0, idx - 1);
          renderQuestion();
        });
        body.appendChild(back);
      }
    }

    function next() {
      if (idx >= QUESTIONS.length - 1) renderResult();
      else {
        idx++;
        renderQuestion();
      }
    }

    function renderSingle(q) {
      var opts = el('div', 'nc-quiz__opts');
      q.options.forEach(function (o, oi) {
        var b = el('button', 'nc-quiz__opt', o.label);
        b.type = 'button';
        if (answers[idx] === oi) b.classList.add('is-picked'); /* 戻る時の回答保持表示 */
        b.addEventListener('click', function () {
          answers[idx] = oi;
          next();
        });
        opts.appendChild(b);
      });
      body.appendChild(opts);
    }

    /* Q2: タップ順に1位→2位→3位(再タップ解除で繰り上げ)。3位まで選ぶと次へ活性 */
    function renderRank(q) {
      var picked = Array.isArray(answers[idx]) ? answers[idx].slice() : [];
      var opts = el('div', 'nc-quiz__opts');
      var foot = el('div', 'nc-quiz__rankfoot');
      var resetB = el('button', 'nc-quiz__rankreset', 'リセット');
      resetB.type = 'button';
      var nextB = el('button', 'nc-btn nc-btn--primary nc-quiz__ranknext', '次へ →');
      nextB.type = 'button';
      function build(focusLabel) {
        opts.innerHTML = '';
        q.options.forEach(function (label) {
          var pos = picked.indexOf(label);
          var b = el('button', 'nc-quiz__opt nc-quiz__opt--rank');
          b.type = 'button';
          b.setAttribute('data-rank-label', label);
          var badge = el('span', 'nc-quiz__rankbadge', pos > -1 ? pos + 1 + '位' : '');
          if (pos > -1) b.classList.add('is-ranked');
          b.appendChild(badge);
          b.appendChild(document.createTextNode(label));
          b.addEventListener('click', function () {
            var pp = picked.indexOf(label);
            if (pp > -1) picked.splice(pp, 1);
            else if (picked.length < 3) picked.push(label);
            build(label); /* 再構築後に同ボタンへフォーカス復元(トラップ維持) */
          });
          opts.appendChild(b);
        });
        nextB.disabled = picked.length < 3;
        answers[idx] = picked.slice(); /* 編集を即同期=戻る→再訪でも最新順位を復元 */
        if (focusLabel != null) {
          var fb = opts.querySelector('[data-rank-label="' + focusLabel + '"]');
          if (fb) fb.focus();
        }
      }
      resetB.addEventListener('click', function () {
        picked = [];
        build();
        var f0 = opts.querySelector('button');
        if (f0) f0.focus();
      });
      nextB.addEventListener('click', function () {
        if (picked.length < 3) return;
        answers[idx] = picked.slice();
        next();
      });
      foot.appendChild(resetB);
      foot.appendChild(nextB);
      body.appendChild(opts);
      body.appendChild(foot);
      build();
    }

    function renderResult() {
      var r = scoreQuiz(answers);
      var meta = LINE_META[r.rec];
      bar.style.width = '100%';
      sub.textContent = '診断結果';
      body.innerHTML = '';
      var wrap = el('div', 'nc-quiz__result nc-quiz__result--' + r.rec);
      wrap.appendChild(el('p', 'nc-quiz__result-desc', 'あなたにおすすめのラインは…'));
      wrap.appendChild(el('p', 'nc-quiz__result-line', meta.name));
      /* 度数バー: 必ず ブルー度→ピンク度→プレミアム度 の固定順(得点順に並べ替えない) */
      var total = r.scores.blue + r.scores.pink + r.scores.premium;
      var bars = el('div', 'nc-quiz__bars');
      QTYPES.forEach(function (t) {
        var pct = total > 0 ? Math.round((r.scores[t] / total) * 100) : 0; /* ゼロ除算ガード */
        var row = el('div', 'nc-quiz__brow nc-quiz__brow--' + t);
        row.appendChild(el('span', 'nc-quiz__blabel', TYPE_LABELS[t]));
        var track = el('span', 'nc-quiz__btrack');
        var fill = el('span', 'nc-quiz__bfill');
        track.appendChild(fill);
        row.appendChild(track);
        row.appendChild(el('span', 'nc-quiz__bval', pct + '%'));
        bars.appendChild(row);
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            fill.style.width = pct + '%';
          });
        });
      });
      wrap.appendChild(bars);
      wrap.appendChild(el('p', 'nc-quiz__result-desc', meta.desc));
      var cta = el('a', 'nc-btn nc-btn--primary', 'もっと詳しくみる →');
      cta.href = COMPARE_URLS[r.rec];
      cta.target = '_blank';
      cta.rel = 'noopener';
      wrap.appendChild(cta);
      var again = el('button', 'nc-quiz__back', 'もう一度診断する');
      again.type = 'button';
      again.addEventListener('click', function () {
        answers = [];
        idx = 0;
        renderQuestion();
      });
      wrap.appendChild(again);
      body.appendChild(wrap);
    }

    var start = card.querySelector('[data-nc-quiz-start]');
    if (start) start.addEventListener('click', renderQuestion);
  }

  /* ============================================================
     2. 3D リングカルーセル
     ============================================================ */
  var rings = {};

  /* ---- アイドル自動回転(2026-07-25・ホームLINE UPから移植) ----
     「6秒で90°左回りスイープ→2秒静止」のリズム式(easeInOutSine)。
     ⚠️カテゴリ固有: リングは「サイズを選ぶ」で開いている間だけ存在する意思決定UIなので、
        **開いているステージのみ**回す(rg.open)。金額を読んでいる最中に動かさないため、
        開いた直後も4秒の無操作待ちを置く。
     休止条件: ホバー(マウスのみ)/キーボードフォーカス/ドラッグ/他アニメ/タブ裏/
        スクロール中/最後の操作から4秒未満。中断したら静止フェーズへ戻し、再開時は
        最寄りスナップ-90°へ距離比例時間で掃引=前面が常に定位置へ自己修復する */
  if (!REDUCED) {
    window.addEventListener(
      'scroll',
      function () {
        var now = performance.now();
        for (var k in rings) if (rings[k]) rings[k].lastUser = now;
      },
      { passive: true },
    );
    var SWEEP_MS = 6000,
      DWELL_MS = 2000;
    var autoPrev = null;
    var autoFrame = function (ts) {
      if (autoPrev === null) autoPrev = ts;
      var dt = Math.min(50, ts - autoPrev);
      autoPrev = ts;
      for (var k in rings) {
        var rg = rings[k];
        if (!rg || !rg.n) continue;
        var eligible =
          !document.hidden &&
          rg.open &&
          !rg.hovered &&
          !rg.focused &&
          !rg.dragging &&
          !rg.raf &&
          ts - rg.lastUser >= 4000;
        if (!eligible) {
          rg.autoPhase = 'dwell';
          rg.autoT = DWELL_MS; /* 静止消化済み扱い=再開時すぐスイープへ */
          continue;
        }
        rg.autoT = (rg.autoT || 0) + dt;
        if (rg.autoPhase !== 'sweep') {
          if (rg.autoT < DWELL_MS) continue;
          rg.autoFrom = rg.theta;
          rg.autoTarget = Math.round(rg.theta / rg.step) * rg.step - rg.step;
          var dist = Math.abs(rg.autoTarget - rg.autoFrom);
          rg.autoDur = Math.max(800, (SWEEP_MS * dist) / rg.step);
          rg.autoPhase = 'sweep';
          rg.autoT = 0;
          continue;
        }
        var p = Math.min(1, rg.autoT / rg.autoDur);
        var ease = 0.5 - 0.5 * Math.cos(Math.PI * p); /* easeInOutSine */
        rg.theta = rg.autoFrom + (rg.autoTarget - rg.autoFrom) * ease;
        rg.paint();
        if (p >= 1) {
          rg.autoPhase = 'dwell';
          rg.autoT = 0;
        }
      }
      requestAnimationFrame(autoFrame);
    };
    requestAnimationFrame(autoFrame);
  }

  function Ring(stage) {
    var self = this;
    this.stage = stage;
    this.ring = stage.querySelector('[data-nc-ring]');
    this.track = stage.querySelector('[data-nc-track]');
    this.cards = Array.prototype.slice.call(stage.querySelectorAll('[data-nc-card]'));
    /* ドットインジケータは撤去済(2026-07-25オーナー指示)。
       将来また出す場合に備えて参照だけ残すが、不在でも落ちないこと */
    this.dotsWrap = stage.querySelector('[data-nc-dots]');
    this.dots = [];
    this.n = this.cards.length;
    this.step = this.n > 0 ? 360 / this.n : 90;
    this.theta = 0;
    this.velocity = 0;
    this.dragging = false;
    this.moved = 0;
    this.raf = null;
    this.lastFront = -1; /* チップポップ用(初回paintは発火させない) */
    this.lastUser = performance.now(); /* 自動回転の休止判定 */
    this.hovered = false;
    this.focused = false;
    this.open = false; /* 「サイズを選ぶ」で開いている間だけ自動回転する */
    if (this.n === 0) return;

    if (this.dotsWrap) {
      this.dots = this.cards.map(function () {
        var d = document.createElement('span');
        d.className = 'nc-ring__dot';
        self.dotsWrap.appendChild(d);
        return d;
      });
    }

    // pointer drag / flick
    var lastX = 0,
      lastT = 0;
    this.ring.addEventListener('pointerdown', function (e) {
      self.dragging = true;
      self.lastUser = performance.now();
      self.moved = 0;
      self.velocity = 0;
      lastX = e.clientX;
      lastT = performance.now();
      /* ⚠️ここで setPointerCapture してはいけない(2026-07-25・実バグ修正)。
         捕捉すると click の発火先が <a class="nc-card"> ではなく .nc-ring へ再ターゲットされ、
         **アンカーの既定動作(遷移)が起きなくなる**(ホーム側で実測・同一実装のためここも同症状)。
         捕捉は「実際にドラッグと判定できてから」pointermove側で行う */
      self.pointerId = e.pointerId;
      self.captured = false;
      if (self.raf) {
        cancelAnimationFrame(self.raf);
        self.raf = null;
      }
    });
    this.ring.addEventListener('pointermove', function (e) {
      if (!self.dragging) return;
      var dx = e.clientX - lastX;
      var now = performance.now();
      var dt = Math.max(1, now - lastT);
      self.moved += Math.abs(dx);
      /* ドラッグ成立時点で初めて捕捉=指がリング外へ出ても追従。タップでは捕捉しない */
      if (!self.captured && self.moved > 8) {
        try {
          self.ring.setPointerCapture(e.pointerId);
          self.captured = true;
        } catch (err) {}
      }
      self.theta += dx * 0.35;
      self.velocity = ((dx * 0.35) / dt) * 16; // deg per frame (60fps 基準)
      lastX = e.clientX;
      lastT = now;
      self.paint();
    });
    var endDrag = function () {
      if (!self.dragging) return;
      self.dragging = false;
      if (self.captured) {
        try {
          self.ring.releasePointerCapture(self.pointerId);
        } catch (err) {}
        self.captured = false;
      }
      self.lastUser = performance.now();
      self.glide();
    };
    this.ring.addEventListener('pointerup', endDrag);
    this.ring.addEventListener('pointercancel', endDrag);

    // click: ドラッグでなければ、前面以外のカードは前面へ回転 (遷移させない)
    this.cards.forEach(function (cardEl, i) {
      cardEl.addEventListener('click', function (e) {
        if (self.moved > 8) {
          e.preventDefault();
          return;
        }
        /* 「正面かどうか」は theta の丸め(frontIndex)ではなく**実際の向き**で判定(2026-07-25)。
           自動回転のスイープ中は theta が中間値で frontIndex が見た目と食い違い、
           正面に見えるカードを押しても遷移せず回転だけしていた。
           depth=cos(角度) が 0.55 超(=±約57°以内)なら実質正面→素直に遷移させる */
        var depth = Math.cos(((i * self.step + self.theta) * Math.PI) / 180);
        if (depth <= 0.55) {
          e.preventDefault();
          self.rotateTo(i);
        }
      });
      cardEl.setAttribute('draggable', 'false');
    });

    // keyboard
    this.ring.addEventListener('keydown', function (e) {
      self.lastUser = performance.now();
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        self.rotateTo(self.frontIndex() - 1);
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        self.rotateTo(self.frontIndex() + 1);
      } else if (e.key === 'Enter') {
        var front = self.cards[self.frontIndex()];
        self.moved = 0; /* 直前ドラッグの残値でクリックガードが誤爆しないように */
        if (front && document.activeElement === self.ring) front.click();
      }
    });

    /* 左右ナビ矢印(2026-07-25・PC専用)。向きはドラッグと同じ「リングを押す」感覚
       (ホームのオーナー実機FBで確定した向きに合わせる):
       ›=リングを右へ回す(左のカードが前面へ) / ‹=左へ回す(右のカードが前面へ) */
    var prevBtn = stage.querySelector('[data-nc-prev]');
    var nextBtn = stage.querySelector('[data-nc-next]');
    if (prevBtn)
      prevBtn.addEventListener('click', function () {
        self.lastUser = performance.now();
        self.rotateTo(self.frontIndex() + 1);
      });
    if (nextBtn)
      nextBtn.addEventListener('click', function () {
        self.lastUser = performance.now();
        self.rotateTo(self.frontIndex() - 1);
      });

    /* 自動回転の休止シグナル。pointerenterはマウス限定
       (タッチはleaveが来ずhovered残留で永久停止する既往) */
    stage.addEventListener('pointerenter', function (e) {
      if (!e.pointerType || e.pointerType === 'mouse') self.hovered = true;
    });
    stage.addEventListener('pointerleave', function () {
      self.hovered = false;
      self.lastUser = performance.now();
    });
    stage.addEventListener('focusin', function (e) {
      /* キーボード由来(:focus-visible)のみ休止。無条件trueにすると矢印クリック後に
         フォーカスが残って自動回転が永久停止する(ホームで実際に踏んだバグ) */
      var fv = true;
      try {
        fv = e.target.matches(':focus-visible');
      } catch (err) {}
      self.focused = fv;
    });
    stage.addEventListener('focusout', function () {
      self.focused = false;
      self.lastUser = performance.now();
    });

    this.paint();
  }

  Ring.prototype.radius = function () {
    var w = this.ring.clientWidth || 320;
    /* PC(リング幅720px以上)は枠を目一杯使う(2026-07-25・ホームLINE UPと同式)。
       モバイル/タブレットは従来式のまま */
    if (w >= 720) return Math.min(470, w * 0.4);
    return Math.min(340, Math.max(180, w * 0.36));
  };

  /* カードを実測センタリング(2026-07-25)。
     旧: CSSの margin-top:-150px は「中身は300px」という決め打ちで、実高328px超のため
     前面カードがドットに重なっていた(実測)。規格が1行/2行でカード高も変わるので、
     各カードの offsetHeight から個別に算出する。開いた直後とリサイズ時だけ実行(毎フレームは走らせない) */
  Ring.prototype.center = function () {
    for (var i = 0; i < this.n; i++) {
      var c = this.cards[i];
      var h = c.offsetHeight;
      if (h > 0) c.style.marginTop = -(h / 2) + 'px';
    }
  };

  Ring.prototype.frontIndex = function () {
    // theta が -i*step のとき i が前面
    var i = Math.round(-this.theta / this.step) % this.n;
    return ((i % this.n) + this.n) % this.n;
  };

  Ring.prototype.paint = function () {
    var r = this.radius();
    var front = this.frontIndex();
    for (var i = 0; i < this.n; i++) {
      var angle = i * this.step + this.theta;
      var rad = (angle * Math.PI) / 180;
      var depth = Math.cos(rad); // 1=前面, -1=背面
      var norm = (depth + 1) / 2;
      var c = this.cards[i];
      c.style.transform =
        'rotateY(' +
        angle +
        'deg) translateZ(' +
        r +
        'px) rotateY(' +
        -angle +
        'deg) scale(' +
        (0.8 + 0.2 * norm) +
        ')';
      c.style.opacity = String(0.4 + 0.6 * norm);
      c.style.zIndex = String(100 + Math.round(depth * 50));
      c.classList.toggle('nc-card--front', i === front);
      c.tabIndex = i === front ? 0 : -1;
      c.setAttribute('aria-hidden', i === front ? 'false' : 'true');
      if (this.dots[i]) this.dots[i].classList.toggle('nc-ring__dot--on', i === front);
    }
    /* 前面切替の瞬間に日数チップをポップ(2026-07-25・ホームと同仕様。初回/REDUCEDは発火しない) */
    if (front !== this.lastFront) {
      if (this.lastFront >= 0 && !REDUCED) {
        var chip = this.cards[front].querySelector('.nc-card__size');
        if (chip) {
          chip.classList.remove('nc-chip-pop');
          void chip.offsetWidth; /* アニメ再スタート用リフロー */
          chip.classList.add('nc-chip-pop');
        }
      }
      this.lastFront = front;
    }
    /* トラックを-r奥へ: 前面カードの遠近拡大率を1.0(等倍)にして文字/画像をシャープに
       (旧: 前面がz=+rで視点に近づきGPU上で約1.2〜1.34倍に引き伸ばされ全体がぼやけていた) */
    this.track.style.transform = 'translateZ(' + -r + 'px)';
  };

  Ring.prototype.glide = function () {
    var self = this;
    function frame() {
      self.velocity *= 0.93;
      self.theta += self.velocity;
      if (Math.abs(self.velocity) < 0.25) {
        self.raf = null;
        self.snap();
        return;
      }
      self.paint();
      self.raf = requestAnimationFrame(frame);
    }
    this.raf = requestAnimationFrame(frame);
  };

  Ring.prototype.snap = function () {
    var target = Math.round(this.theta / this.step) * this.step;
    this.animateTo(target);
  };

  Ring.prototype.rotateTo = function (index) {
    // index を前面 (= theta = -index*step に最も近い等価角) へ
    var current = this.theta;
    var target = -index * this.step;
    var diff = ((((target - current) % 360) + 540) % 360) - 180; // 最短経路
    this.animateTo(current + diff);
  };

  Ring.prototype.animateTo = function (target) {
    var self = this;
    if (REDUCED) {
      this.theta = target;
      this.paint();
      return;
    }
    if (this.raf) cancelAnimationFrame(this.raf);
    var from = this.theta;
    var start = null;
    var dur = 450;
    function frame(ts) {
      if (start === null) start = ts;
      var t = Math.min(1, (ts - start) / dur);
      var ease = 1 - Math.pow(1 - t, 3);
      self.theta = from + (target - from) * ease;
      self.paint();
      if (t < 1) self.raf = requestAnimationFrame(frame);
      else self.raf = null;
    }
    this.raf = requestAnimationFrame(frame);
  };

  function openStage(key, viaQuiz) {
    var line = document.getElementById('nc-line-' + key);
    if (!line) return;
    var stage = line.querySelector('[data-nc-stage]');
    var btn = line.querySelector('[data-nc-open]');
    if (!stage || stage.classList.contains('nc-stage--open')) return;
    stage.classList.add('nc-stage--open');
    if (btn) btn.setAttribute('aria-expanded', 'true');
    if (!rings[key]) rings[key] = new Ring(stage);
    // 浮かび上がり: stagger
    var cards = stage.querySelectorAll('[data-nc-card]');
    Array.prototype.forEach.call(cards, function (c, i) {
      setTimeout(
        function () {
          c.style.opacity = '';
          c.style.transform = '';
          rings[key].paint();
        },
        REDUCED ? 0 : 90 * i + 60,
      );
    });
    /* 開いた直後に実測センタリング(閉じている間は offsetHeight が取れないため必ずここで)。
       入場staggerの完了後にもう一度測り直す(画像ロードで高さが動くケースの保険) */
    rings[key].center();
    rings[key].paint();
    setTimeout(
      function () {
        if (!rings[key]) return;
        rings[key].center();
        rings[key].paint();
      },
      REDUCED ? 60 : 90 * cards.length + 260,
    );
    /* 自動回転の対象にする。開いた瞬間を「操作」とみなし、4秒の無操作待ちを置く */
    rings[key].open = true;
    rings[key].lastUser = performance.now();
    if (viaQuiz && !REDUCED) {
      // 診断経由: 軽いお披露目スピン
      setTimeout(function () {
        rings[key].theta = -30;
        rings[key].animateTo(0);
      }, 420);
    }
  }

  function closeStage(key) {
    var line = document.getElementById('nc-line-' + key);
    if (!line) return;
    var stage = line.querySelector('[data-nc-stage]');
    var btn = line.querySelector('[data-nc-open]');
    if (!stage) return;
    stage.classList.remove('nc-stage--open');
    if (btn) btn.setAttribute('aria-expanded', 'false');
    /* 閉じたら自動回転の対象から外す(不可視のまま回し続けない) */
    if (rings[key]) rings[key].open = false;
  }

  function initStages(root) {
    var buttons = root.querySelectorAll('[data-nc-open]');
    Array.prototype.forEach.call(buttons, function (btn) {
      btn.hidden = false; // JS 有効時のみ開閉ボタンを出す (無効時は常時グリッド)
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-nc-open');
        var line = document.getElementById('nc-line-' + key);
        var stage = line && line.querySelector('[data-nc-stage]');
        if (stage && stage.classList.contains('nc-stage--open')) closeStage(key);
        else openStage(key, false);
      });
    });
  }

  /* ============================================================
     3. scroll-reveal
     ============================================================ */
  function initReveal(root) {
    var targets = root.querySelectorAll('.nc-reveal');
    if (REDUCED || !('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(targets, function (t) {
        t.classList.add('nc-in');
      });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) {
            en.target.classList.add('nc-in');
            io.unobserve(en.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 },
    );
    Array.prototype.forEach.call(targets, function (t) {
      io.observe(t);
    });
  }

  /* ============================================================
     boot
     ============================================================ */
  /* ============================================================
     情景パノラマ背景(2026-07-25オーナー指示)
     固定レイヤー(.nc-pan = position:fixed / z-index:-1)の5景を、各アンカー
     (hero / 3ライン / history)の中心と画面中央の距離でクロスフェード+微パララックス。
     ⚠️sticky不可(.naturism-cat{overflow-x:hidden}がスクロールコンテナを作る)ため固定方式。
     REDUCED/情景DOM不在では何もしない(CSSが1枚目のみ淡く静止させる)
     ============================================================ */
  function initScenic(root) {
    if (REDUCED) return;
    var pan = document.querySelector('[data-nc-pan]');
    if (!pan) return;
    var panes = [];
    Array.prototype.forEach.call(pan.querySelectorAll('[data-nc-pano]'), function (im) {
      var anchor = document.querySelector(im.getAttribute('data-nc-pano'));
      if (anchor) panes.push({ im: im, el: anchor });
    });
    if (!panes.length) return;
    pan.classList.add('is-live'); /* CSSの静止フォールバックを解除 */
    var mobileMQ = window.matchMedia('(max-width: 749px)');
    var raf = 0;
    function tick() {
      raf = 0;
      if (!pan.isConnected) {
        window.removeEventListener('scroll', onScroll);
        window.removeEventListener('resize', onScroll);
        return;
      }
      var vh = window.innerHeight || 1;
      var peak = mobileMQ.matches ? 0.45 : 0.55;
      panes.forEach(function (pn) {
        var r = pn.el.getBoundingClientRect();
        var rel = (r.top + r.height / 2 - vh / 2) / vh; /* 0=アンカー中心が画面中央 */
        /* アンカーが5個ありホーム(3個)より間隔が広いので、溶け幅を1.0vhに拡げて
           全景opacity=0の「白抜け」区間が出ないようにする */
        var w = 1 - Math.min(1, Math.abs(rel));
        w = w * w * (3 - 2 * w); /* smoothstep */
        var op = w * peak;
        if (op < 0.004) {
          /* 5枚が常時non-zeroだとコンポジタが1枚もスキップできない=リング3基の3D合成と競合する */
          pn.im.style.opacity = '0';
          pn.im.style.visibility = 'hidden';
          return;
        }
        pn.im.style.visibility = 'visible';
        pn.im.style.opacity = op.toFixed(3);
        var ty = Math.max(-5, Math.min(5, rel * 5)); /* top:-6%/height:112%の遊びの内側 */
        pn.im.style.transform = 'translateY(' + ty.toFixed(2) + '%) scale(1.06)';
      });
    }
    function onScroll() {
      if (!raf) raf = requestAnimationFrame(tick);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    /* ステージ開閉で文書高が変わるので追従(max-heightのtransition終了で発火) */
    root.addEventListener('transitionend', function (e) {
      if (e.propertyName === 'max-height') onScroll();
    });
    tick();
  }

  function boot() {
    var root = document.querySelector('[data-nc-root]');
    if (!root) return;
    initQuiz(root);
    initStages(root);
    initReveal(root);
    initScenic(root);
    /* 画面幅が変わるとリング半径もカード高も変わる=開いているリングを測り直す */
    var rzTimer = null;
    window.addEventListener(
      'resize',
      function () {
        clearTimeout(rzTimer);
        rzTimer = setTimeout(function () {
          for (var k in rings) {
            if (!rings[k] || !rings[k].open) continue;
            rings[k].center();
            rings[k].paint();
          }
        }, 160);
      },
      { passive: true },
    );
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
